import React from 'react';
import { Modal } from '../ui/Modal';

// Renders the backend's standardized report envelope ({ headers, rows, summary }) on screen.
// Every one of the 16+ reports shares this exact shape, so one viewer covers all of them.
const summaryLabel = (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, (c) => c.toUpperCase()).trim();

export default function ReportViewer({ open, onClose, reportName, data, loading }) {
  const headers = data?.headers || [];
  const rows = data?.rows || [];
  const summary = data?.summary || {};
  const summaryEntries = Object.entries(summary).filter(([, v]) => v !== null && v !== undefined);

  return (
    <Modal open={open} onClose={onClose} title={reportName || 'Report'} subtitle={data?.generatedAt ? `Generated ${data.generatedAt}` : undefined} size="xl">
      {loading && <p className="text-[12px] text-gray-400 text-center py-10">Loading report…</p>}

      {!loading && (
        <>
          {summaryEntries.length > 0 && (
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
              {summaryEntries.map(([key, value]) => (
                <div key={key} className="bg-gray-50 border border-gray-100 rounded-lg p-3">
                  <p className="text-[10px] text-gray-400 uppercase tracking-wide mb-0.5">{summaryLabel(key)}</p>
                  <p className="text-[15px] font-semibold text-gray-900 font-mono">{String(value)}</p>
                </div>
              ))}
            </div>
          )}

          {rows.length === 0 ? (
            <div className="py-10 text-center text-[12px] text-gray-400">No data available for the selected filters.</div>
          ) : (
            <div className="overflow-auto border border-gray-100 rounded-lg">
              <table className="w-full text-[12px]">
                <thead className="bg-gray-50 sticky top-0">
                  <tr>
                    {headers.map((h, i) => (
                      <th key={i} className="text-left font-semibold text-gray-500 uppercase tracking-wide px-3 py-2 whitespace-nowrap">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {rows.map((row, ri) => (
                    <tr key={ri} className="hover:bg-gray-50">
                      {row.map((cell, ci) => (
                        <td key={ci} className="px-3 py-2 text-gray-700 whitespace-nowrap">{cell === null || cell === undefined ? '—' : String(cell)}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </Modal>
  );
}
